import { API_BASE_URL } from './prospects';

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function buildQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    q.set(key, String(value));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export async function fetchAffiliateTrackingChart(month) {
  const res = await fetch(
    `${API_BASE_URL}/affiliate/tracking/chart${buildQuery({ month })}`,
    { headers: { ...authHeaders() } },
  );
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.data?.message || 'Impossible de charger le graphique.');
  }
  return body;
}

export async function fetchAffiliateTracking(params = {}) {
  const res = await fetch(
    `${API_BASE_URL}/affiliate/tracking${buildQuery(params)}`,
    { headers: { ...authHeaders() } },
  );
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.data?.message || 'Impossible de charger les commissions.');
  }
  return body;
}

export async function downloadAffiliateTrackingCsv(params = {}) {
  const res = await fetch(
    `${API_BASE_URL}/affiliate/tracking/export${buildQuery(params)}`,
    { headers: { ...authHeaders() } },
  );
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.data?.message || 'Export CSV impossible.');
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `commissions-affilie-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function currentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
